import { useEffect, useState } from "react";
import { Button } from "@swot/base-components";

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
};

export function useCmtsPwaInstallPrompt() {
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent | null>(null);
  useEffect(() => {
    const handler = (event: Event) => {
      event.preventDefault();
      setPromptEvent(event as BeforeInstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  async function install(): Promise<"accepted" | "dismissed" | "unavailable"> {
    if (!promptEvent) return "unavailable";
    await promptEvent.prompt();
    const choice = await promptEvent.userChoice;
    setPromptEvent(null);
    return choice.outcome;
  }

  return { canInstall: Boolean(promptEvent), install };
}

export function CmtsPwaInstallPanel() {
  const prompt = useCmtsPwaInstallPrompt();
  if (!prompt.canInstall) return null;
  return (
    <div className="cmts-pwa-install-panel">
      <span>Install CMTS as a secure enterprise PWA for faster access.</span>
      <Button label="Install" variant="secondary" onClick={() => void prompt.install()} />
    </div>
  );
}
